import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App.tsx'
import { initNative, isNativeApp } from './native'

function render() {
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </React.StrictMode>,
  )
}

// On native (Capacitor), hydrate the stored session token before the first
// render so authenticated requests have their bearer token. No-op on web.
if (isNativeApp()) {
  void initNative().finally(render)
} else {
  render()
}
